import {createSlice, type PayloadAction} from '@reduxjs/toolkit';
import type {ISelectItem} from '../../shared/types';

interface IRoleImpersonationPrefill {
  domain: ISelectItem | null;
  project: ISelectItem | null;
  securityGroup: ISelectItem | null;
}

interface IRoleImpersonation {
  showRoleImpersonationModal: boolean;
  prefill: IRoleImpersonationPrefill;
}

const initialState: IRoleImpersonation = {
  showRoleImpersonationModal: false,
  prefill: {
    domain: null,
    project: null,
    securityGroup: null,
  },
};

const roleImpersonationSlice = createSlice({
  name: 'roleImpersonation',
  initialState,
  reducers: {
    setShowRoleImpersonationModal(state, action: PayloadAction<boolean>) {
      state.showRoleImpersonationModal = action.payload;
    },
    setRoleImpersonationPrefill(
      state,
      action: PayloadAction<Partial<IRoleImpersonationPrefill>>
    ) {
      state.prefill = {
        ...state.prefill,
        ...action.payload,
      };
    },
    clearRoleImpersonationPrefill(state) {
      state.prefill = {domain: null, project: null, securityGroup: null};
    },
  },
});

export const {
  setShowRoleImpersonationModal,
  setRoleImpersonationPrefill,
  clearRoleImpersonationPrefill,
} = roleImpersonationSlice.actions;
export default roleImpersonationSlice.reducer;
